import { render, staticRenderFns } from "./ListaAbonosProveedor.vue?vue&type=template&id=2d0fea9e"
import script from "./ListaAbonosProveedor.vue?vue&type=script&lang=js"
export * from "./ListaAbonosProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports